<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M37.5 26v-5a2 2 0 00-2-2h-4v-5a2 2 0 00-2-2h-11a2 2 0 00-2 2v5h-4a2 2 0 00-2 2v5h-4a2 2 0 00-2 2v6a2 2 0 002 2h35a2 2 0 002-2v-6a2 2 0 00-2-2zm-3-4v4h-9v-4h9zm-15-7h9v4h-9zm-6 7h9v4h-9zm3 11h-9v-4h9zm12 0h-9v-4h9zm12 0h-9v-4h9z"/></svg>